import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material'
import Navbar from './components/Navbar'
import Home from './pages/Home'
import Reading from './pages/Reading'
import AskPandit from './pages/AskPandit'
import Compatibility from './pages/Compatibility'
import Pricing from './pages/Pricing'

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#8B7FFF' },
    secondary: { main: '#D4537E' },
    background: {
      default: '#0D0B1A',
      paper: '#120F20',
    },
    text: {
      primary: '#E8E6FF',
      secondary: '#8B85B8',
    },
    divider: '#1E1A3A',
  },
  typography: {
    fontFamily: '"Inter", "Roboto", sans-serif',
    h4: { fontWeight: 500 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 20,
        },
        contained: {
          background: '#534AB7',
          '&:hover': { background: '#3C3489' },
        },
        outlined: {
          borderColor: '#3D3580',
          color: '#A89EFF',
          '&:hover': { background: '#1A1530', borderColor: '#534AB7' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: '#120F20',
          border: '1px solid #1E1A3A',
          boxShadow: 'none',
          borderRadius: 12,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            background: '#0D0B1A',
            '& fieldset': { borderColor: '#1E1A3A' },
            '&:hover fieldset': { borderColor: '#3D3580' },
            '&.Mui-focused fieldset': { borderColor: '#534AB7' },
          },
          '& .MuiInputLabel-root': { color: '#8B85B8' },
          '& .MuiInputLabel-root.Mui-focused': { color: '#A89EFF' },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          background: '#0D0B1A',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#1E1A3A' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#3D3580' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#534AB7' },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          background: '#1A1530',
          border: '1px solid #3D3580',
          color: '#A89EFF',
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          background: '#120F20',
          border: '1px solid #1E1A3A',
          boxShadow: 'none',
          '&:before': { display: 'none' },
          borderRadius: '12px !important',
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: { background: '#1E1A3A', borderRadius: 5 },
        bar: { background: '#534AB7', borderRadius: 5 },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: { borderColor: '#1E1A3A' },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: { background: '#1A1530', border: '1px solid #1E1A3A' },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: '#E8E6FF',
          '&:hover': { background: '#1E1A3A' },
        },
      },
    },
  },
})

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reading" element={<Reading />} />
          <Route path="/ask" element={<AskPandit />} />
          <Route path="/compatibility" element={<Compatibility />} />
          <Route path="/pricing" element={<Pricing />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}